<template>
  <div class="pa-section pa-section-story-list-widget-new">
    <StoryBookSelector
     :stories="stories"
     @changeStory="handleChangeStory"
    />
    
    <StoryChapterList
     :chapterList="chapterList"
     @selectChapter="handleSelectChapter"
    />

    <StoryWidgetLoading
     :isLoading="isLoading"
    />
  </div>
</template>

<script>
import StoryBookSelector  from '@/components/Pages/Home/PAStoryListWidget/StoryBookSelector/StoryBookSelector.vue'
import StoryChapterList   from '@/components/Pages/Home/PAStoryListWidget/StoryChapterList/StoryChapterList.vue'

import StoryWidgetLoading from '@/components/Pages/Home/PAStoryListWidget/StoryWidgetLoading/StoryWidgetLoading.vue'

import {GetStoryList} from '@/graphql/queries/Story.graphql'
import {GetStoryData} from '@/graphql/queries/Story.graphql'
import {GetChapterList} from '@/graphql/queries/Story.graphql'

export default {
  components : {
    StoryBookSelector,
    StoryChapterList,

    StoryWidgetLoading
  },

  data(){
    return {
      selectedStoryBookId : null,
      isLoading           : false
    }
  },

  apollo : {
    stories : {
      query : GetStoryList,
      watchLoading (isLoading) {
        this.isLoading = isLoading;
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    storyData : {
      query : GetStoryData,
      variables(){
        return {
          id  : this.selectedStoryBookId
        };
      },

      skip(){
        if(this.selectedStoryBookId === null){
          return true;
        }else{
          return false;
        }
      },

      watchLoading (isLoading) {
        this.isLoading = isLoading;
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    chapterList : {
      query : GetChapterList,
      variables(){
        return {
          storyId: this.storyData.id
        }
      },

      skip(){
        if( (typeof this.storyData === 'undefined') || (this.storyData === null) ){
          return true;
        }else{
          return false;
        }
      },

      watchLoading (isLoading) {
        this.isLoading = isLoading;
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  methods : {
    handleChangeStory(data){
      if(typeof data.id === 'undefined') return;

      this.selectedStoryBookId = data.id;

      this.$store.dispatch({
        type      : 'storyBook/updateSelectedStory',
        storyId   : this.selectedStoryBookId,
      });
    },

    handleSelectChapter(chapterData){
      this.$store.dispatch({
        type      : 'storyBook/updateSelectedStory',
        chapterId : chapterData.id
      });

      this.$store.dispatch({
        type        : 'storyBook/updateIsOpenStoryModal',
        value       : true,
        initialize  : true,
      });
    }
  }
}
</script>

<style lang="scss">
.pa-section{
  &-story-list-widget-new{
    padding-top:.4rem !important;
    padding-bottom:.4rem;
    position: relative;
  }
}
</style>